"use strict";
/* eslint-disable @typescript-eslint/no-explicit-any */
Object.defineProperty(exports, "__esModule", { value: true });
var TelemetryHelper = /** @class */ (function () {
    function TelemetryHelper() {
    }
    TelemetryHelper.getTelemetryEventData = function (sdk, telemetryEvent, customData) {
        var logData = {
            Description: customData.Description,
            ElapsedTimeInMilliseconds: customData.ElapsedTimeInMilliseconds,
            EndpointUrl: customData.EndpointUrl,
            EndpointId: customData.EndpointId,
            ErrorCode: customData.ErrorCode,
            Event: telemetryEvent,
            ExceptionDetails: customData.ExceptionDetails,
            ShouldBubbleToHost: customData.ShouldBubbleToHost,
            SubscriptionId: sdk.id
        };
        return logData;
    };
    return TelemetryHelper;
}());
exports.default = TelemetryHelper;
//# sourceMappingURL=TelemetryHelper.js.map